<template>
  <div>
    <v-btn @click="dialog = true" class="mr-2" rounded color=""
      >General Ledger</v-btn
    >
    <v-dialog v-model="dialog" persistent width="1300">
      <v-card>
        <v-card-title>
          General Ledger
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="printGeneralLedger"
            :disabled="!coaEntryItems.length"
            class="mr-2"
          >
            <v-icon left>mdi-printer</v-icon>
            Print
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div>
            <p>Pick any Account Title and click Submit</p>

            <div class="d-flex">
              <v-select
                label="Account Title"
                :items="chart_of_accounts"
                item-text="account_title"
                item-value="id"
                v-model="coaSearch"
                class="mr-2"
              ></v-select>
              <div class="d-flex">
                <p>From Date</p>
                <input type="date" v-model="fromDate" />
                <p>To Date</p>
                <input type="date" v-model="toDate" />
                <v-btn
                  color="primary"
                  class="mt-4 ml-2"
                  @click="searchCoa"
                  :loading="loading"
                  >Submit</v-btn
                >
              </div>
            </div>
            <v-text-field label="Search" v-model="search"></v-text-field>
          </div>

          <div>
            <v-data-table
              :items="coaEntryItems"
              :headers="coaEntryHeaders"
              :search="search"
              dense
              :items-per-page="50"
              :custom-filter="filterByDate"
            >
              <!-- for debit and credit entries -->
              <template #item.credit="{ item }">
                <span
                  v-if="!item.is_debit"
                  :class="
                    item.chart_of_account.normal_balance == 'credit'
                      ? 'success--text'
                      : 'red--text'
                  "
                  >{{ item.amount ? item.amount.toLocaleString() : "" }}</span
                >
              </template>
              <template #item.debit="{ item }">
                <span
                  v-if="item.is_debit"
                  :class="
                    item.chart_of_account.normal_balance == 'debit'
                      ? 'success--text'
                      : 'red--text'
                  "
                  >{{ item.amount ? item.amount.toLocaleString() : "" }}</span
                >
              </template>
              <template #item.balance="{ item }">
                <span class="primary--text">{{
                  item.balance ? item.balance.toLocaleString() : ""
                }}</span>
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="dialog = false"> Close</v-btn>
          <v-spacer></v-spacer>
          <p class="caption grey--text">chartOfAccountsEntries.vue</p>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex/dist/vuex.common.js";
import axios from "axios";
import moment from "moment";
export default {
  props: ["item"],
  data() {
    return {
      search: "",
      coaSearch: 5,
      dialog: false,
      loading: false,
      coaEntryItems: [],
      fromDate: null,
      toDate: null,
      selectedYear: "",
      coaEntryHeaders: [
        { text: "id", value: "id" },
        { text: "Account Title", value: "chart_of_account.account_title" },
        { text: "Debit", value: "debit" },
        {
          text: "Credit",
          value: "credit",
        },
        { text: "Balance", value: "balance" },
        { text: "Journal Date", value: "date" },

        { text: "Invoice ID", value: "invoice_id" },
        { text: "Customer Name", value: "invoice.customer.customer_name" },
        { text: "Remarks", value: "remarks" },
        { text: "Date Created", value: "created_at" },
        { text: "Inserted by", value: "inserted_by" },
      ],
      months: [
        { text: "January", value: "01" },
        { text: "Febuary", value: "02" },
        { text: "March", value: "03" },
        { text: "April", value: "04" },
        { text: "May", value: "05" },
        { text: "June", value: "06" },
        { text: "July", value: "07" },
        { text: "August", value: "08" },
        { text: "September", value: "09" },
        { text: "October", value: "10" },
        { text: "November", value: "11" },
        { text: "December", value: "12" },
      ],
      years: ["2024", "2025", "2026", "2027", "2028"],
    };
  },
  methods: {
    filterByDate() {
      var filteredCoaEntries = this.coaEntryItems.filter((c) => {
        return moment(c.date).isBetween(
          this.fromDate,
          this.toDate,
          "day",
          "[]"
        );
      });
      this.coaEntryItems = filteredCoaEntries;
    },
    submit() {
      return;
    },
    async searchCoa() {
      console.log(this.fromDate);
      let response = await axios.get(
        "/coaEntries/" +
          this.coaSearch +
          "/" +
          this.fromDate +
          "/" +
          this.toDate
      );
      this.coaEntryItems = response.data;
      console.log(this.coaEntryItems);
      this.filterByDate();
    },

    printGeneralLedger() {
      if (!this.coaEntryItems.length) {
        alert("No data to print. Please search for entries first.");
        return;
      }

      let confirmation = window.confirm(
        "Proceed with printing the General Ledger?"
      );
      if (!confirmation) return;

      // Create a print-friendly window with the current data
      this.generatePrintWindow();
    },

    generatePrintWindow() {
      const printWindow = window.open("", "_blank");
      const selectedAccount = this.chart_of_accounts.find(
        (account) => account.id === this.coaSearch
      );
      const accountTitle = selectedAccount
        ? selectedAccount.account_title
        : "All Accounts";

      // Calculate totals
      const totalDebit = this.coaEntryItems
        .filter((item) => item.is_debit)
        .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

      const totalCredit = this.coaEntryItems
        .filter((item) => !item.is_debit)
        .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

      let printContent = `

        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <meta http-equiv="X-UA-Compatible" content="ie=edge">
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css" integrity="sha384-rbsA2VBKQhggwzxH7pPCaAqO46MgnOM80zW1RWuH61DGLwZJEdK2Kadq2F9CUG65" crossorigin="anonymous">
            <title>General Ledger - ${accountTitle}</title>
            <style>
                body { font-family: Arial, sans-serif; }
                .header { text-align: center; margin-bottom: 30px; }
                .company-info { margin-bottom: 20px; }
                table { width: 100%; border-collapse: collapse; }
                th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                th { background-color: #f2f2f2; font-weight: bold; }
                .text-right { text-align: right; }
                .text-center { text-align: center; }
                .total-row { font-weight: bold; background-color: #f8f9fa; }
                .signature-section { margin-top: 50px; }
                .footer { text-align: center; margin-top: 100px; font-size: 12px; }
                @media print {
                    body { margin: 0; }
                    .no-print { display: none; }
                }
            </style>
        </head>
        <body onload="window.print()">
            <div class="header">
                <div class="company-info">
                    <h3 class="font-weight-bold">JMB Computer and Laptop Repair Services</h3>
                    <h4>General Ledger</h4>
                    <p><strong>Account:</strong> ${accountTitle}</p>
                    <p><strong>Period:</strong> ${moment(this.fromDate).format(
                      "MMMM DD, YYYY"
                    )} to ${moment(this.toDate).format("MMMM DD, YYYY")}</p>
                </div>
            </div>
            
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Account Title</th>
                        <th class="text-right">Debit</th>
                        <th class="text-right">Credit</th>
                        <th class="text-right">Balance</th>
                        <th>Journal Date</th>
                        <th>Invoice ID</th>
                        <th>Customer Name</th>
                        <th>Remarks</th>
                        <th>Inserted By</th>
                    </tr>
                </thead>
                <tbody>
                    ${this.coaEntryItems
                      .map(
                        (entry) => `
                        <tr>
                            <td>${entry.id}</td>
                            <td>${
                              entry.chart_of_account?.account_title || ""
                            }</td>
                            <td class="text-right">
                                ${
                                  entry.is_debit
                                    ? entry.amount
                                      ? parseFloat(
                                          entry.amount
                                        ).toLocaleString()
                                      : ""
                                    : ""
                                }
                            </td>
                            <td class="text-right">
                                ${
                                  !entry.is_debit
                                    ? entry.amount
                                      ? parseFloat(
                                          entry.amount
                                        ).toLocaleString()
                                      : ""
                                    : ""
                                }
                            </td>
                            <td class="text-right">
                                ${
                                  entry.balance
                                    ? parseFloat(entry.balance).toLocaleString()
                                    : ""
                                }
                            </td>
                            <td>${entry.date || ""}</td>
                            <td>${entry.invoice_id || "Manual Input"}</td>
                            <td>${
                              entry.invoice?.customer?.customer_name || ""
                            }</td>
                            <td>${entry.remarks || ""}</td>
                            <td>${entry.inserted_by || ""}</td>
                        </tr>
                    `
                      )
                      .join("")}
                </tbody>
            </table>
            
            <div class="mt-4">
                <h5>Summary</h5>
                <p><strong>Total Debit:</strong> ${totalDebit.toLocaleString()}</p>
                <p><strong>Total Credit:</strong> ${totalCredit.toLocaleString()}</p>
                <p><strong>Total Entries:</strong> ${
                  this.coaEntryItems.length
                }</p>
            </div>
            
            <div class="signature-section">
                <p>Prepared by: ___________________________</p>
                <p class="mt-5">Noted by: ______________________________</p>
            </div>
            
            <div class="footer">
                <p>***** This is a system generated report *****</p>
                <p>jmbcomputers.com</p>
            </div>
        </body>
        </html>
      `;

      printWindow.document.write(printContent);
      printWindow.document.close();
    },
  },
  computed: {
    ...mapGetters({
      chart_of_accounts: "chart_of_account/chart_of_accounts",
    }),
  },
  created() {
    this.fromDate = moment().startOf("month").format("YYYY-MM-DD");
    this.toDate = moment().endOf("month").format("YYYY-MM-DD");
  },
};
</script>

<style lang="scss" scoped></style>
